/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiResponseCarpoolValidationResult } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface CarpoolTesterServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param commuteId 
     */
    carpoolTesterControllerByCommuteId0(commuteId: string, extraHttpRequestParams?: any): Observable<Array<ApiResponseCarpoolValidationResult>>;

    /**
     * 
     * 
     * @param commuteId 
     */
    carpoolTesterControllerByCommuteId1(commuteId: string, extraHttpRequestParams?: any): Observable<Array<ApiResponseCarpoolValidationResult>>;

    /**
     * 
     * 
     * @param commuteIds 
     */
    carpoolTesterControllerByCommuteIds0(commuteIds: Array<string>, extraHttpRequestParams?: any): Observable<ApiResponseCarpoolValidationResult>;

    /**
     * 
     * 
     * @param commuteIds 
     */
    carpoolTesterControllerByCommuteIds1(commuteIds: Array<string>, extraHttpRequestParams?: any): Observable<ApiResponseCarpoolValidationResult>;

}
